module.exports = __webpack_public_path__ + "static/media/announcement-24px - blue.12934197.svg";